module.exports = __webpack_public_path__ + "static/img/case-gl-page-bg-02.94c26a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/gl/case-gl-page-bg-02.jpg
// module id = 01O1
// module chunks = 1